// extracted by mini-css-extract-plugin
export default {"value":"SaftyFactorsSection_value__dsHrC","value1":"SaftyFactorsSection_value1__JaBcC","wrapper":"SaftyFactorsSection_wrapper__Af27v"};